import { render, staticRenderFns } from "./LoadingRealEstateDevelopment.vue?vue&type=template&id=6ecc18e7&lang=true"
import script from "./LoadingRealEstateDevelopment.vue?vue&type=script&lang=js"
export * from "./LoadingRealEstateDevelopment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports